import { useAutoSync } from '@/hooks/useAutoSync';

/**
 * Component that runs auto-sync logic when mounted.
 * Should be placed inside QueryClientProvider and after user context is available.
 */
export function AutoSyncProvider({ children }: { children: React.ReactNode }) {
  useAutoSync();
  return <>{children}</>;
}
